import { apiClient as client } from "./client";

const loginEndpoint = "/login";
const logoutEndpoint = "/logout";
const societesEndpoint = "/societes";
const usersEndpoint = "/users";
const addUserEndpoint = "/user/add";

const clientsEndpoint = "/clients";
const missionsEndpoint = "/missions";
const moreInfoMissionEndpoint = "/mission/info";

const salariesEndpoint = "/salaries";

const initPassworEndpoint = "/user/resetPassword";

const sendSubscriptionEndpoint = "/sendSubscription";

// const getListings = () => client.get(endpoint);

const getSocietes = () => {
  return client.get(societesEndpoint, {}, { withCredentials: true });
};

const getUsers = (filters) => {
  return client.get(usersEndpoint, filters, { withCredentials: true });
};

const addUser = (newUser) => {
  console.log("newuser", newUser);
  return client.post(addUserEndpoint, newUser, { withCredentials: true });
};

const sendSubscription = (subscription) => {
  console.log("subscription", subscription);
  var key = subscription.getKey ? subscription.getKey("p256dh") : "";
  var auth = subscription.getKey ? subscription.getKey("auth") : "";

  var valueToSend = JSON.stringify({
    endpoint: subscription.endpoint,
    // Take byte[] and turn it into a base64 encoded string suitable for
    // POSTing to a server over HTTP
    key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : "",
    auth: auth
      ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth)))
      : "",
  });
  return client.post(sendSubscriptionEndpoint, valueToSend, {
    withCredentials: true,
  });
};

const getClients = (filters) => {
  return client.get(clientsEndpoint, filters, { withCredentials: true });
};

const getSalaries = (filters) => {
  return client.get(salariesEndpoint, filters, { withCredentials: true });
};

const getMissions = (filters) => {
  return client.get(missionsEndpoint, filters, { withCredentials: true });
};

const moreInfoMission = (idSociete, idMission) => {
  let filters = {};
  return client.get(
    moreInfoMissionEndpoint + "/" + idSociete + "/" + idMission,
    filters,
    {
      withCredentials: true,
    }
  );
};

const initPassword = (idUser) => {
  let filters = {};
  return client.get(initPassworEndpoint + "/" + idUser, filters, {
    withCredentials: true,
  });
};

const logout = () => {
  return client.get(logoutEndpoint, {}, { withCredentials: true });
};

const login = (user, onUploadProgress) => {
  return client.post(
    loginEndpoint,
    user,
    { withCredentials: true },
    {
      onUploadProgress: (progress) => {
        if (onUploadProgress) {
          onUploadProgress(progress.loaded / progress.total);
        }
      },
    }
  );
};

export default {
  login,
  logout,
  getSocietes,
  getUsers,
  addUser,
  getSalaries,
  getMissions,
  getClients,
  initPassword,
  moreInfoMission,
  sendSubscription,
};
